import { render, staticRenderFns } from "./orderStatistics.vue?vue&type=template&id=477d01da&scoped=true"
import script from "./orderStatistics.vue?vue&type=script&lang=js"
export * from "./orderStatistics.vue?vue&type=script&lang=js"
import style0 from "./orderStatistics.vue?vue&type=style&index=0&id=477d01da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d01da",
  null
  
)

export default component.exports